import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": {}
}
const presenceData = createSlice({
    name:'presenceData',
    initialState,
    reducers:{
        addPresenceData: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        }
    }
});

export default presenceData.reducer
export const addPresenceData = presenceData.actions.addPresenceData